import qs from 'qs';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import PendingTimesheets from 'features/pending-timesheets/components/pending-timesheets.component';
import { RootState } from 'store/root-reducer';
import { setShowMockData, setUrl } from 'features/pending-timesheets/redux/pending-timesheets-slice';
import 'styles/app-styles.scss';
import DisablingSpinner from './disabling-spinner';
import useConfig from '../features/config/use-config';
import { setAppConfig } from 'redux/global-elements-slice';
import { AppConfig } from '../features/config/config.model';
import MessageModal from './message-modal.component';
import dayjs from 'dayjs';
import FeatureFlags from 'features/config/FeatureFlags';

const App = ({ location: { search } }: { location: { search: string } }): JSX.Element => {
    const {
        facilityId = '6C10EBBC-3F89-E911-A959-000D3A34E00B',
        payCycleDate = '2020-10-31',
        clientOnlineTimesheetApprovalSecret,
        showMockData,
    } = qs.parse(search, {
        ignoreQueryPrefix: true,
    });

    const { isLoading, data } = useConfig();

    const dispatch = useDispatch();
    dispatch(setUrl(clientOnlineTimesheetApprovalSecret as string));
    dispatch(setShowMockData(typeof showMockData === 'string' && showMockData.toLowerCase() === 'true'));

    React.useEffect(() => {
        if (!isLoading) {
            dispatch(setAppConfig(data));
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isLoading, data]);

    const { hospitalName, payPeriodStart, payPeriodEnd, showMockData: userRequestedMockData } = useSelector(
        (state: RootState) => state.pendingTimesheets,
    );

    const config = useSelector((state: RootState) => state.globalElements.appConfig as AppConfig);

    return config ? (
        <FeatureFlags>
            <PendingTimesheets
                facilityId={facilityId as string}
                payCycleDate={payCycleDate as string}
                url={clientOnlineTimesheetApprovalSecret as string}
                hospitalName={hospitalName}
                payPeriodStart={dayjs(payPeriodStart)}
                payPeriodEnd={dayjs(payPeriodEnd)}
                userRequestedMockData={userRequestedMockData}
            />

            <DisablingSpinner />

            <MessageModal />
        </FeatureFlags>
    ) : // @todo: display something meaningful if config can't be retrieved
    null;
};

export default App;
